import api from "../utils/api";

export async function getPermission(action, user_id) {
  try {
    const hasPermission = await api.post(
      process.env.VUE_APP_USER_CORE_API_BASE + "permission",
      { action, user_id },
    );
    return hasPermission;
  } catch (error) {
    console.log("Erro ao chamar API de permissões: ", error);
  }
}
